export default __webpack_public_path__ + "static/media/Highway.e67ae23c.svg";